import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { InlineWidget } from "react-calendly";

class CalendarModal extends Component {
  render() {
    const { t } = this.props;
    return (
      <>
        {this.props.show && (
          <div
            className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready"
            style={{
              overflow: "auto",
              background: "rgba(0, 0, 0, 0.5)",
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) this.props.close();
            }}
          >
            <div
              className="position-relative mx-auto"
              style={{
                width: "90%",
                maxWidth: "750px",
                overflow: "hidden",
                borderRadius: "12px"
              }}
            >
              <button
                onClick={() => this.props.close()}
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "0px",
                  background: "rgba(255,255,255,0.9)",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  zIndex: 10,
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1
                }}
              >
                &times;
              </button>
              <div style={{ height: "950px", margin: "-1px" }}>
                <InlineWidget
                  url="https://calendly.com/rawbids/30min"
                  styles={{ height: "950px", minWidth: "320px" }}
                  pageSettings={{
                    backgroundColor: 'ffffff',
                    hideEventTypeDetails: false,
                    hideLandingPageDetails: false,
                    primaryColor: 'ff7a56',
                    textColor: '333333'
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withTranslation("general")(CalendarModal);
